import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS } from '@/shared';
import { useGetOrdenTrabajo } from '@/shared/actions/erp';
import { useCheckPermissions, useLoaders } from '@/shared/hooks';
import RevisionOrdenTrabajoTec from '../../shared/components/SaveOrdenTrabajo/RevisionOrdenTrabajoTec';

export type InstalacionRevisarOTPageProps = {};

const InstalacionRevisarOTPage: React.FC<
  InstalacionRevisarOTPageProps
> = () => {
  useCheckPermissions(PermissionsEnum.revision_contabilidad_tecnico);
  const returnUrlInstalacionesTecnicoPage =
    ROUTER_PATHS.tecnico.ordenenTrabajoNav;
  // const navigate = useNavigate();

  // const setAlert = useUiStore(s => s.setAlert);

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetOrdenTrabajo(id!);
  useLoaders(isLoading || isRefetching);

  // validate state
  // useEffect(() => {
  //   if (!data?.data?.id_orden_trabajo) return;
  //   if (
  //     data?.data?.estado_orden_trabajo !==
  //     EstadosOrdenTrabajoEnumChoice.ESPERA_ACTUALIZAR
  //   ) {
  //     setAlert(
  //       true,
  //       'La orden de trabajo no esta en estado de espera de actualización',
  //       AlertSeverityEnum.error
  //     );
  //     navigate(returnUrlInstalacionesTecnicoPage);
  //   }
  // }, [data?.data?.id_orden_trabajo]);

  if (isLoading || isRefetching) return null;
  if (!data?.data?.id_orden_trabajo)
    return <Navigate to={returnUrlInstalacionesTecnicoPage} />;

  return (
    <RevisionOrdenTrabajoTec
      title="Revisión de Orden de Trabajo"
      ordentrabajo={data.data}
    />
  );
};

export default InstalacionRevisarOTPage;
